import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, of, retry, throwError } from 'rxjs';
import { CartItem } from '../models/cart-item.model';
import { AddToCartRequest } from '../models/add-to-cart-request.model';
import { Cart } from '../models/cart.model';
import { UpdateCartItemDto } from '../models/update-cart-item-dto';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  private cartApiUrl = `${environment.apiBaseUrl}/api/cart`;

  private cartItemCount = new BehaviorSubject<number>(0);
  cartItemCount$ = this.cartItemCount.asObservable();


  constructor(private http: HttpClient) {
    //if (!this.auth.isTokenExpired()) {
    //  this.refreshCartCount();
    //}
  }

  addToCart(cart: AddToCartRequest): Observable<any>{
    return this.http.post<any>(`${this.cartApiUrl}/add`, cart);
    //return this.http.post<any>(`${this.cartApiUrl}/add`, cart).subscribe(() => {
    //  this.refreshCartCount(); // refresh count after successful add
    //});
  }
  // 🔄 Refresh count after operations
  refreshCartCount(): void {
    //const userId = localStorage.getItem('userId'); // or sessionStorage.getItem
    this.getCartItems().subscribe(cartItems => {
      const count = cartItems.items.reduce((sum, item) => sum + item.quantity, 0);
      this.cartItemCount.next(count);
    });
  }

  clearCart(): Observable<void> {
    return this.http.delete<void>(this.cartApiUrl);
  }

  getCartItems(): Observable<Cart> {
    const userId = localStorage.getItem('userId'); // or sessionStorage.getItem
    if (!userId) {
      console.error('User ID is missing from session.');
      return throwError(() => new Error('User not logged in'));
    }
    //return this.http.get<Cart>(`${this.cartApiUrl}/GetCartItems/${userId}`);
    return this.http.get<Cart>(`${this.cartApiUrl}/GetCartItems/${userId}`).pipe(
      retry(3), // Retry the request 3 times if it fails
      catchError(error => {
        console.error('API GetCartItems failed', error);
        return of(); // Return an empty list on error
      })
    );
  }

  updateCartItem(productId: number, quantity: number): Observable<CartItem> {
/*    const userId = localStorage.getItem('userId');*/
    const userId: string = localStorage.getItem('userId')!;
    const updateCartItemDto: UpdateCartItemDto = {
      productId: productId,
      quantity: quantity,
      userId: userId
    };
    return this.http.put<CartItem>(`${this.cartApiUrl}/${productId}`, updateCartItemDto);
  }


  removeCartItem(productId: number): Observable<void> {
    return this.http.delete<void>(`${this.cartApiUrl}/remove/${productId}`);
  }
}

